export const AppFooter = () => <div style={{
    color: " #201f1f", display: "flex", alignItems: "center", position: "fixed", zIndex: 2, bottom: "10px", width: "100vw", padding: "0 5vw", justifyContent: "center",
    backgroundColor: "#fff"
}}>© 2023 Groupe Créative | Tous droits réservés</div>
